/* ==========================================================================
   HOME PASSION · ileri hareket: odak + paralaks + atalet + ilerleme cubugu

   TIKLAMA HATASI — uc sebep birden kapatildi:

   1) setPointerCapture KALDIRILDI. Kapsayici isaretciyi yakalayinca tarayici
      pointerdown/pointerup hedefini kapsayiciya tasiyor; click olayi artik
      <a> uzerinde degil kapsayicida doguyor ve BAGLANTI ACILMIYOR. Suruklenen
      karusellerde "linkler calismiyor" sikayetinin klasik sebebi budur.
      Yerine document uzerinde pointermove/pointerup dinleniyor.

   2) moved SAYACI ARTIK SIFIRLANIYOR. Eskiden yalnizca pointerdown'da
      sifirlaniyordu; dokunmatikte pointerdown erken donduugu icin deger
      surukleme sonrasi takili kaliyor, capture asamasindaki click iptali
      SONRAKI butun tiklamalari da olduruyordu. Simdi birakisdan 350ms sonra
      sifirlaniyor.

   3) Tiklama iptali YALNIZCA FARE surukleyisinde. Dokunmatikte zaten native
      kaydirma kullaniliyor, orada iptal etmenin anlami yok.

   Yumusak kaydirma icin hp-scroll.js kullanilir (native smooth guvenilmez).
   ========================================================================== */
(function(){
  'use strict';
  var RM=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var raf=window.requestAnimationFrame?window.requestAnimationFrame.bind(window)
        :function(f){return setTimeout(f,16)};

  function enhance(vp,opts){
    if(!vp||vp.dataset.plus) return; vp.dataset.plus='1';
    opts=opts||{};
    var focus = opts.focus !== false;
    vp.classList.add('hp-crsl-in');
    if(focus) vp.classList.add('hp-focus');

    var wrap=document.createElement('div'); wrap.className='hp-crsl-wrap';
    vp.parentNode.insertBefore(wrap,vp); wrap.appendChild(vp);
    var prog=document.createElement('div'); prog.className='hp-prog';
    var bar=document.createElement('i'); prog.appendChild(bar); wrap.appendChild(prog);

    function updProg(){
      var max=vp.scrollWidth-vp.clientWidth;
      var ratio=vp.clientWidth/vp.scrollWidth;
      if(ratio>=0.999||max<=0){ prog.style.display='none'; return; }
      prog.style.display='';
      var w=Math.max(12,ratio*100);
      bar.style.setProperty('--w',w+'%');
      var p=vp.scrollLeft/max;
      bar.style.setProperty('--x',(p*(100/w*100-100))+'%');
    }

    var cards=[].slice.call(vp.children);
    function updFocus(){
      if(!focus||RM) return;
      var r=vp.getBoundingClientRect(), cx=r.left+r.width/2, half=r.width/2;
      for(var i=0;i<cards.length;i++){
        var c=cards[i], cr=c.getBoundingClientRect();
        if(cr.right<r.left-240||cr.left>r.right+240) continue;
        var ccx=cr.left+cr.width/2;
        var d=Math.min(1,Math.abs(ccx-cx)/half);
        var f=1-d*d;
        c.style.setProperty('--hs',(1-0.05*d).toFixed(4));
        c.style.setProperty('--hsat',(0.85+0.15*f).toFixed(3));
        c.style.setProperty('--hbr',(0.95+0.05*f).toFixed(3));
        c.style.setProperty('--hf',f.toFixed(3));
        var m=c.querySelector('img,video');
        if(m) m.style.setProperty('--hpx',((ccx-cx)*0.04).toFixed(1)+'px');
      }
    }

    var ticking=false;
    function onScroll(){ if(ticking) return; ticking=true;
      raf(function(){ updFocus(); updProg(); ticking=false; }); }
    vp.addEventListener('scroll',onScroll,{passive:true});
    addEventListener('resize',onScroll,{passive:true});

    function live(){ vp.classList.add('enter');
      setTimeout(function(){ vp.classList.add('live'); updFocus(); updProg(); },850); }
    if('IntersectionObserver' in window && !RM){
      var io=new IntersectionObserver(function(es){
        es.forEach(function(e){ if(e.isIntersecting){ live(); io.unobserve(vp); } });
      },{threshold:.12});
      io.observe(vp);
    } else { live(); }
    setTimeout(live,2200);

    /* ---------------- fare ile surukleme ---------------- */
    var down=false, sx=0, sl=0, moved=0, vlast=0, vel=0, tlast=0, anim=null, pid=null;
    var resetT=null;

    function stopGlide(){ if(anim){ clearTimeout(anim); anim=null; } }

    vp.addEventListener('pointerdown',function(e){
      if(e.pointerType==='touch') return;      /* dokunmatik: native kaydirma */
      if(e.button!==0) return;
      if(e.target.closest('button, select, input, [data-vadd], .hp-vid-snd')) return;

      stopGlide();
      if(resetT){ clearTimeout(resetT); resetT=null; }
      if(vp.__hpAnim && window.cancelAnimationFrame){ cancelAnimationFrame(vp.__hpAnim); vp.__hpAnim=null; }

      down=true; moved=0; vel=0; pid=e.pointerId;
      sx=e.clientX; sl=vp.scrollLeft; vlast=e.clientX; tlast=Date.now();
      /* setPointerCapture BILEREK YOK — click hedefini bozuyor */
    });

    function onMove(e){
      if(!down || e.pointerId!==pid) return;
      var d=e.clientX-sx;
      if(Math.abs(d)>4 && !vp.classList.contains('drag')){ vp.classList.add('drag'); }
      moved=Math.abs(d);
      vp.scrollLeft=sl-d;
      var now=Date.now(), dt=now-tlast;
      if(dt>8){ vel=(e.clientX-vlast)/dt; vlast=e.clientX; tlast=now; }
      onScroll();
    }

    function release(e){
      if(!down) return;
      if(e && e.pointerId!=null && e.pointerId!==pid) return;
      down=false; pid=null;
      vp.classList.remove('drag');

      var v=-vel*18;
      if(Math.abs(v)<0.8){ settle(); }
      else {
        (function glide(){
          v*=0.93; vp.scrollLeft+=v; onScroll();
          if(Math.abs(v)>0.5){ anim=setTimeout(glide,16); }
          else { anim=null; settle(); }
        })();
      }

      /* Sayaci temizle — aksi halde bir sonraki tiklama da iptal edilir */
      if(resetT) clearTimeout(resetT);
      resetT=setTimeout(function(){ moved=0; resetT=null; }, 350);
    }

    function settle(){
      var step=window.hpStep?window.hpStep(vp):400;
      var i=Math.round(vp.scrollLeft/step);
      if(window.hpScrollTo) window.hpScrollTo(vp,i*step,320);
      else vp.scrollLeft=i*step;
    }

    document.addEventListener('pointermove',onMove,{passive:true});
    document.addEventListener('pointerup',release);
    document.addEventListener('pointercancel',release);
    addEventListener('blur',function(){ release(); });

    /* Yalnizca gercekten SURUKLENDIYSE tiklamayi iptal et */
    vp.addEventListener('click',function(e){
      if(moved>6){ e.preventDefault(); e.stopPropagation(); moved=0; }
    },true);

    [400,1400,2800].forEach(function(ms){ setTimeout(function(){ updFocus(); updProg(); },ms); });
  }

  function boot(root){
    (root||document).querySelectorAll('.hp-vid-vp').forEach(function(v){ enhance(v,{focus:true}); });
    (root||document).querySelectorAll('.hp-vcat-vp').forEach(function(v){ enhance(v,{focus:true}); });
    (root||document).querySelectorAll('.hp-crsl-vp:not(.hp-vcat-vp)').forEach(function(v){ enhance(v,{focus:false}); });
  }

  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',function(){boot()}); }
  else { boot(); }
  document.addEventListener('shopify:section:load',function(e){ boot(e.target); });
})();
